export default __webpack_public_path__ + "63d1b4479864de62a47bcb41b2e5f329.png";